// i18n.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

// Paramètre anti-cache des traductions : la version réellement déployée
// (APP_VERSION de config.js, injecté par entrypoint.sh, ou REACT_APP_VERSION).
// package.json porte « dev » en permanence : après un déploiement, le
// navigateur pouvait garder les anciennes traductions (F-FE-05).
import { appVersion } from './config/config';
const storedLang =
    (typeof window !== 'undefined' && window.localStorage?.getItem('lang')) ||
    'fr';

i18n
    .use(HttpApi)
    .use(LanguageDetector) // Utilisation du détecteur de langue (optionnel)
    .use(initReactI18next) // Intégration avec react-i18next
    .init({
        lng: storedLang, // Langue par défaut
        fallbackLng: 'fr', // Langue de repli
        supportedLngs: ['fr', 'en', 'ar'], // Langues supportées
        interpolation: {
            escapeValue: false, // React échappe déjà les valeurs par défaut
        },
        backend: {
            loadPath: `/locales/{{lng}}/{{ns}}.json?v=${appVersion}`, // Chemin vers les fichiers de traduction
        },
        detection: {
            order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'], // Détection automatique des langues
            lookupLocalStorage: 'lang', // Clé personnalisée pour la langue
            caches: ['localStorage', 'cookie'], // Où stocker la langue détectée
        },
    });

export default i18n;
